import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import api, { INSTAGRAM, resolveImg } from "../lib/api";

export default function InstaFeed() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/instagram").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 mt-24 pb-8" data-testid="insta-feed">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold">From our feed</p>
          <h2 className="mt-3 text-3xl sm:text-4xl text-primary font-medium">Real homes, styled simply</h2>
        </div>
        <a
          href={INSTAGRAM}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-sm text-primary link-underline"
          data-testid="insta-follow-link"
        >
          <Instagram size={16} /> Follow @aetheldecor
        </a>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {posts.slice(0, 8).map((p, i) => (
          <motion.a
            key={p.id}
            href={p.link || INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: (i % 4) * 0.07 }}
            className="group relative block aspect-square overflow-hidden bg-muted"
            data-testid={`insta-post-${p.id}`}
          >
            <img
              src={resolveImg(p.image)}
              alt={p.caption || "Aethel Decor on Instagram"}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/60 transition-colors duration-300 flex flex-col items-center justify-center gap-2 p-4">
              <Instagram
                size={22}
                className="text-primary-foreground opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              />
              {p.caption && (
                <p className="text-xs text-primary-foreground/90 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-2">
                  {p.caption}
                </p>
              )}
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
